import { useParams } from 'react-router-dom';
import { CourseDetailView } from '@/views/CourseDetailView';
import { MainLayout } from '@/widgets/layouts/MainLayout';

const CourseDetailPage = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return null;
  }

  return (
    <MainLayout headerTitle="Course Detail">
      <CourseDetailView courseId={Number(id)} />
    </MainLayout>
  );
};

export default CourseDetailPage;

